$(document).ready(function () {
    $('[data-hero-slider]').slick('unslick')
    $('[data-hero-slider-nav]').slick('unslick')
    $('.product-nav').hide()
    $('.home-hero-slider').slick({
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000, 
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            },
        ]
    })
  
  });